import { Component, OnInit } from '@angular/core';
import { Http, Response, RequestOptions, Headers } from '@angular/http';
import { Observable } from 'rxjs/Observable';

/*---------------------------------------------- Variables Liferay ----------------------------------------------*/
declare var portletNameRetrieveCardLiferay: any; // Nombre del portlet en Liferay
declare var JsonGetContent: any; // URL del contenido con las condiciones del servicio
declare var retrieveCardIdLiferay: any; // Identificador del contenido con las condiciones del servicio
declare var i18nVS: any;
declare var getPDFAction: any;
declare var idCiudadLiferay: any;
@Component({
  selector: 'app-retrieve-card',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})



export class AppComponent implements OnInit {
    /*---------------------------------------------- Constantes ----------------------------------------------*/

    /*---------------------------------------------- Variables Liferay ----------------------------------------------*/
    portletName = ''; // Nombre del portlet

    /*------------------------------------------------ Variables VSC -------------------------------------------------*/
    URLContenido: string;
    theHtmlString = '';
    i18nL = i18nVS;
    getPDFAction = getPDFAction;
    

    public getContents (PLID: string) {
        this.leerDatos(PLID).subscribe(res => this.comprobandoJson(res));
    }

    public comprobandoJson (res) {
        var resultado: string = res._body;
        this.theHtmlString = resultado;
    }

    public leerDatos (PLID: string): Observable<Response> {
        var body = portletNameRetrieveCardLiferay + 'contentPLID=' + PLID;
        const headers = new Headers({ 'Content-Type': 'application/x-www-form-urlencoded' }); // Set content type to JSON
        const options = new RequestOptions({ headers: headers }); // Create a request option      
        return this.http.post(JsonGetContent, body, options);
    }

    //Metodo para crear la URl de invocacion al ajax de generar el PDF.
    //Crea la URl del ajax y la invoca con un click
    public loadPDFFile(pdfType: string) {
       
         //recuperamos un parametro que llega
        var originURL = new URL(window.location.href);              
        var numDossier = originURL.searchParams.get("code")      
        var cityId = idCiudadLiferay;

		//creamos la URL de descarga del pdf y simularmos un click
        const pdfURL = new URL(this.getPDFAction);       		
		pdfURL.searchParams.append(this.portletName+ "code", numDossier);	
		pdfURL.searchParams.append(this.portletName+ "cityId", cityId);	
		if(pdfType == "lostCard"){         
          pdfURL.searchParams.append(this.portletName+ "lostCard", "true");	
        } else {
           pdfURL.searchParams.append(this.portletName+ "brokenCard", "true");	          
        }	
		
        var downloadLink = document.createElement('a');
        // Abrimos en una nueva pestaña
        downloadLink.target = "_blank";
        downloadLink.href = pdfURL.href;
        document.body.appendChild(downloadLink);
        downloadLink.click();
        downloadLink.remove();
    }

   

    /*--------------------------------------------- Eventos ------------------------------------------------------*/
    ngOnInit () {
        this.portletName = portletNameRetrieveCardLiferay;
        this.getContents(retrieveCardIdLiferay);
    }

    /*--------------------------------------------- Constructores ------------------------------------------------*/
    constructor(private http: Http) { }

    /*--------------------------------------------- Constructores ------------------------------------------------*/
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts